<template>
    <div v-if="dataSource" class="p-relative">

        <Toolbar v-on:toolbar-button-click="onToolbarClick"/>

        <div class="white-panel-items">
            <div class="wp-row">
                <div class="info-panel-text info-panel-text-uppercase">
                    <b>{{ dataSource.Data.Object.is_new_record ? $t("Новый_рабочий_процесс") : $t("Рабочий_процесс") }}</b>
                </div>
            </div>
        </div>

        <v-tabs 
            v-model="tab"
            background-color="transparent"
            slider-size="3"
            class="tab-selector-panel"
            mobile-breakpoint="0"
            @change="onTabChanged"
        >
            <v-tabs-slider color="#E43958"></v-tabs-slider>
            <v-tab>
                {{ $t("Карточка") }}
            </v-tab>
            <v-tab v-if="activities">
                {{ $t("Схема") }}
            </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab" class="tab-content-panel">

            <v-tab-item>
                <!-- Карточка процесса -->
                <v-form
                    class="wrapperForm"
                    ref="form"
                    lazy-validation
                >
                    <v-row dense>
						
						<!-- Общая информация -->
                        <v-col cols="12" sm="12" md="6" class="section-wrapper">
                            <v-card flat>
                                <v-card-text>
                                    <div class="form-box-title">{{ $t("Общая_информация") }}</div>

									<!-- Наименование -->
                                    <v-row no-gutters>
                                        <v-col cols="12" sm="12" md="4">
                                            <label class="f-label">{{ $t("Наименование") }}</label>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="8">

                                            <div v-if="isViewMode" class="onlyReadData">
                                                {{ dataSource.Data.Object.Name ?? $t("Не_указано") }}
                                            </div>

                                            <v-text-field
                                                v-else
												v-model="dataSource.Data.Object.Name"
                                                hide-details
                                                outlined
                                                dense
                                                :rules="requiredRule"
                                            >
                                            </v-text-field>
                                        </v-col>
                                    </v-row>

									<!--Поле Версия-->
									<v-row no-gutters>
										<v-col cols="12" sm="12" md="4">
											<label class="f-label">{{ $t("Версия") }}</label>
										</v-col>
										<v-col  cols="12" sm="12" md="8">
											<div class="onlyReadData">
												{{ dataSource.Data.Object.Version }}
											</div>
										</v-col>
									</v-row>

									<!-- Описание -->
                                    <v-row no-gutters>
                                        <v-col cols="12" sm="12" md="4">
                                            <label class="f-label">{{ $t("Описание") }}</label>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="8">

                                            <div v-if="isViewMode" class="onlyReadData">
                                                {{ dataSource.Data.Object.Description ?? $t("Не_указано") }}
                                            </div>

                                            <v-textarea
                                                v-else
												v-model="dataSource.Data.Object.Description"
                                                rows="3"
                                                no-resize
                                                hide-details
                                                required
                                                outlined
                                                dense
                                                :rules="requiredRule"
                                            >
                                            </v-textarea>
                                        </v-col>
                                    </v-row>

                                </v-card-text>
                            </v-card>
                        </v-col>
						
						<!-- Контекст применения -->
                        <v-col cols="12" sm="12" md="6" class="section-wrapper">
                            <v-card flat>
                                <v-card-text>
                                    <div class="form-box-title">{{ $t("Контекст_применения") }}</div>

									<!-- Организация -->
                                    <v-row no-gutters>
                                        <v-col cols="12" sm="12" md="4">
                                            <label class="f-label">{{ $t("Организация") }}</label>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="8">
                                            <div class="onlyReadData">
                                                <v-enterprise-chip v-if="enterpriseIdViewValue" :name="enterpriseIdViewValue" />
                                            </div>
                                            <!-- <v-select
                                                v-else
                                                v-model="dataSource.Data.Object.EnterpriseId"
                                                :items="enterprises"
                                                item-value="id"
                                                item-text="name"
                                                hide-details
                                                outlined
                                                dense
                                                append-icon="fas fa-chevron-down"
                                                :menu-props="{ bottom: true, offsetY: true }"
                                                @click:clear="dataSource.Data.Object.EnterpriseId = guidEmpty"
                                            >
                                            </v-select> -->
                                        </v-col>

                                    </v-row>

                                    <!-- Тип_документа -->
                                    <v-row no-gutters>
                                        <v-col cols="12" sm="12" md="4">
                                            <label class="f-label">{{ $t("Типы_документов") }}</label>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="8">
                                            <div v-if="isViewMode" class="onlyReadData">
                                                {{ contextTypesViewValue }}
                                            </div>
                                            <v-select
                                                v-else
                                                v-model="dataSource.Data.Object.ContextTypes"
                                                :items="docTypes"
                                                :item-value="item => item.id"
                                                :item-text="item => $t(item.name)"
                                                hide-details
                                                outlined
                                                dense
                                                multiple
                                                required
                                                :rules="multipleRule"
                                                append-icon="fas fa-chevron-down"
                                                :menu-props="{ bottom: true, offsetY: true }"
                                            >
                                            </v-select>
                                        </v-col>
                                    </v-row>

                                </v-card-text>
                            </v-card>
                        </v-col>

						<!--Кем создано-->
						<v-col cols="12" sm="12" md="6" class="section-wrapper">
							<v-card flat>
								<v-card-text>
									<div class="form-box-title">{{ $t("Кем_создано") }}</div>
									
									<!--Поле Сведения внес в АИС субъекта-->
									<v-row no-gutters>
										<v-col cols="12" sm="12" md="4">
											<label class="f-label">{{$t("Автор")}}</label>
										</v-col>
										<v-col  cols="12" sm="12" md="8">
											<div class="onlyReadData">
												<v-employee-chip v-if="dataSource.Data.Object.AuthorId" :id="dataSource.Data.Object.AuthorId" :name="authorName" />
											</div>
										</v-col>
									</v-row>

									<!--Поле Дата создания-->
									<v-row no-gutters>
										<v-col cols="12" sm="12" md="4">
											<label class="f-label">{{ $t("Дата_создания") }}</label>
										</v-col>
										<v-col  cols="12" sm="12" md="8">
											<div class="onlyReadData">
												{{ dataSource.Data.Object.CreationDate ? $moment(dataSource.Data.Object.CreationDate).format("DD.MM.YYYY") : $t("Не_указано") }}
											</div>
										</v-col>
									</v-row>

								</v-card-text>
							</v-card>
						</v-col>

                    </v-row>
                </v-form>
            </v-tab-item>

            <v-tab-item v-if="activities">
                <FlowEditor
                    ref="FlowEditor"
                    :is-view-mode="isViewMode"
                    :activities="activities"
                    :enterprise="dataSource.Data.Object.EnterpriseId"
                    :validator="validateSchema"
                    :is-active="tab == 1"
                />
            </v-tab-item>
        </v-tabs-items>

    </div>
</template>

<script>
import { mapGetters } from 'vuex';

import { httpAPI } from "@/api/httpAPI";
import sys from '@/services/system';
import Toolbar from '@/components/documents/Toolbar.vue';
import FlowEditor from '@/components/global/workflow/FlowEditor.vue';

const type = 'WorkFlow.Scheme';
 
export default {
    name: "WorkflowCard",
    components: {
        Toolbar,
        FlowEditor
    },
    asyncComputed: {
        enterprises: {
            async get() {
                let enterprises = await this.$store.dispatch('documents/references/getEnterprises');
                return [ { id: this.guidEmpty, name: this.$t("Любая_организация") }, ...enterprises ];
            },
            default: []
        },
        activities: {
            lazy: true,
            async get() {
                return (await httpAPI({ url: `api/document-templates/activities`, method: 'GET' }))?.data?.Payload ?? [];
            },
            default: []
        }
    },
    computed: {
        ...mapGetters({ requiredRule: 'getRequiredRule', multipleRule: 'getMultipleRule' }),
        ...mapGetters('global/configuration/workflows', { docTypes: 'getWorkFlowDocTypes' }),
        guidEmpty() {
            return sys.guidEmpty();
        },
        isViewMode() {
            return this.dataSource.Data.FormId == "2301021";
        },
        menu() {
            let menu = [];
            return menu.concat(this.dataSource?.Data?.Menu);
        },
        authorName() {
            return this.dataSource.Data.AdditionalObjects[1] ?? "";
        },
        enterpriseIdViewValue() {
            return this.enterprises.find(e => e.id == this.dataSource.Data.Object.EnterpriseId)?.name;
        },
        contextTypesViewValue() {
            if (!this.dataSource.Data.Object.ContextTypes)
                return this.$t("Не_указано");

            return this.docTypes.filter(dt => this.dataSource.Data.Object.ContextTypes.includes(dt.id)).map(dt => dt.name).join(', ');
        }
    },
    data:() => ({
        tab: 0,
        dataSource: null,
        isFlowEditorLoaded: false
    }),
    methods: {
        async onToolbarClick(e, btn) {
            let action = this[btn.Action];

            if (typeof action != 'function') {
                this.$notify.warning(`Действие ${btn.Action} не реализовано`);
                return;
            }

            await this[btn.Action](btn);
        },
        async onTabChanged() {
            if (this.tab == 1 && this.dataSource.Data.Object.Diagramm && this.dataSource.Data.Object.Scheme) {
                while(typeof this.$refs.FlowEditor === 'undefined')
                    await new Promise(resolve => setTimeout(resolve, 100));
                
                if (!this.isFlowEditorLoaded) {
                    this.$refs.FlowEditor.load(this.dataSource.Data.Object.Diagramm, this.dataSource.Data.Object.Scheme);
                    this.isFlowEditorLoaded = true;
                }
            }
        },
        enrichWithActivityMeta(schemeItem) {
            if (!schemeItem) return null;

            let schemeItemCopy = JSON.parse(JSON.stringify(schemeItem));
            let meta = this.activities.find(a => a.Type === schemeItem['__type']);

            if (!meta) return null;

            let ports = meta?.PossibleResultAttributes?.map(pra => pra.Value) ?? [];
            let triggeredPorts = meta?.TriggerAttributes?.filter(ta => schemeItem[ta.Source] == ta.DesiredValue)?.map(ta => ta.Value) ?? [];
            
            for (var prop in schemeItem) {
                let propDesc = meta.Properties?.find(p => p.Name == prop);

                if (!propDesc) continue;

                schemeItem[prop] = {
                    Value: schemeItemCopy[prop],
                    Name: propDesc?.DisplayNameAttribute?.DisplayName,
                    Type: propDesc?.WebEditorAttribute?.Type,
                    Required: ['Workplace'].includes(propDesc?.WebEditorAttribute?.Type) && this.dataSource.Data.Object.EnterpriseId == this.guidEmpty
                        ? false
                        : propDesc?.WebEditorAttribute?.DependsBy
                            ? schemeItemCopy[propDesc.WebEditorAttribute.DependsBy] == true
                            : propDesc?.WebEditorAttribute?.Params?.required
                };
            }

            return { ...schemeItem, Name: meta?.ActivityAttribute?.Name, Ports: ports.concat(triggeredPorts) };
        },
        buildTree(schema, idMap) {
            let starts = schema.filter(a => a.__type.includes('StartActivity'));

            if (starts.length > 1) {
                throw { id: null, message: "Несколько StartActivity" };
            }
            
            if (starts.length == 0) {
                throw { id: null, message: "Нет StartActivity" };
            }

            // берём первую StartActivity
            let start = starts[0];
            let visited = new Set();

            let buildNodes = (activity) => {
                if (!activity) return [];

                if (visited.has(activity.Id))
                    return { ...activity };

                visited.add(activity.Id);

                activity.Transitions = activity.Transitions.map(tr => {
                    let next = idMap.get(tr.ActivityId);
                    return { ...tr, Activity: buildNodes(next) };
                });

                return this.enrichWithActivityMeta(activity);
            }

            let tree = buildNodes(start);

            // поиск не посещённых ('мёртвых') активностей
            for (let id of idMap.keys()) {
                if (!visited.has(id)) {
                    throw { id, message: "Активность не имеет входа" };
                }
            }

            return tree;
        },
        validateTree(root) {
            // вспомогательная фунция для проверки валидного завершения
            let isTerminal = activity => {
                let type = activity.__type || '';
                return type.includes('EndActivity') || type.includes('ErrorActivity');
            };

            let isStart = root.__type.includes('StartActivity');

            if (!isStart) {
                throw { id: root.Id, message: "Нет StartActivity" };
            }

            // активности, которые мы посетили
            let visited = new Set();
            // кеш, id -> true/false, указывает, гарантированно ли ветка ведет к завершению
            let goodPath = new Map();
            // активные идентификаторы в текущем стеке DFS (для обработки циклов)
            let inStack = new Set();

            function dfs(activity) {
                let id = activity.Id;

                // если уже проверяли — возвращаем результат
                if (goodPath.has(id))
                    return goodPath.get(id);

                // помечаем как посещённую
                visited.add(id);

                // проверка обязательных параметров - НУЖНО ДОПОЛНИТЬ ПО ТИПАМ ДАННЫХ
                for (let [key, value] of Object.entries(activity)) {
                    if (value?.Required && (value.Value == null)) {
                        throw { id, message: `Обязательный параметр '${key}' не заполнен` };
                    }
                }

                // если завершающая активность — хорошая ветка, true
                if (isTerminal(activity)) {
                    goodPath.set(id, true);
                    return true;
                }

                let transitions = activity.Transitions || [];

                // если нет переходов и активность не завершающая — плохая ветка
                if (transitions.length === 0) {
                    throw { id, message: `Нет перехода к завершению` };
                }

                // проверка наличия перехода по умолчания - НУЖНО БУДЕТ ПЕРЕДЕЛАТЬ НА ПРИЗНАК
                if (!transitions.some(t => t)) {
                    throw { id, message: `Нет перехода по умолчанию` };
                }

                if (activity.__type.includes("IfElseActivity")) {
                    let hasTrue = transitions.some(t => t.Key === "True");
                    let hasFalse = transitions.some(t => t.Key === "False");

                    if (!hasTrue || !hasFalse) {
                        throw { id, message: "Для условия необходимо указать переходы по \"Да\" и \"Нет\"" };
                    }
                }

                for (let transition of transitions) {
                    // определяем следующую активность
                    let targetId = transition.ActivityId;

                    // если цикл — пропускаем
                    if (inStack.has(targetId))
                        continue;
                    
                    // добавляем текущий узел в стек
                    inStack.add(id);
                    // рекурсия в следующую активность
                    dfs(transition.Activity)
                    // удаляем узел из стека
                    inStack.delete(id);
                }

                goodPath.set(id, true);
                return true;
            }

            // запуск от StartActivity
            dfs(root);
        },
        validateParallels(activitiesIdMap) {
            // находим все ParallelActivity и EndFlowActivity
            let parallels = [...activitiesIdMap.values()].filter(x => x.__type.includes("ParallelActivity"));
            let endFlows = [...activitiesIdMap.values()].filter(x => x.__type.includes("EndFlowActivity"));

            // количество ParallelActivity должно совпадать с количеством EndFlowActivity
            if (parallels.length !== endFlows.length) {
                throw { id: null, message: "Количество ParallelActivity не совпадает с количеством EndFlowActivity" };
            }

            for (let p of parallels) {
                let startId = p.Id;
                // ThreadId ParallelActivity указывает на соответствующий EndFlowActivity
                let endId = p.ThreadId;
                let endNode = activitiesIdMap.get(endId);

                // проверяем существование соответствующего EndFlowActivity
                if (!endNode || !endNode.__type.includes("EndFlowActivity")) {
                    throw { id: startId, message: "Для ParallelActivity не найден соответствующий EndFlowActivity" };
                }

                // проверка соответсвия ThreadId
                if (endNode.ThreadId !== startId) {
                    throw { id: startId, message: "Несогласованность ParallelActivity и EndFlowActivity" };
                }

                for (let tr of p.Transitions) {
                    let firstId = tr.ActivityId ?? tr.Activity?.Id;

                    let stack = [firstId];
                    let visited = new Set();
                    let reachedEnd = false;

                    while (stack.length) {
                        let curId = stack.pop();

                        if (visited.has(curId))
                            continue;

                        visited.add(curId);

                        // если достигли EndFlowActivity — отмечаем
                        if (curId === endId) {
                            reachedEnd = true;
                            continue;
                        }

                        let node = activitiesIdMap.get(curId);

                        // если это вложенная параллель — переходим сразу к её EndFlowActivity
                        if (node.__type.includes("ParallelActivity")) {
                            let nestedEndFlow = activitiesIdMap.get(node.ThreadId);

                            if (nestedEndFlow && nestedEndFlow.__type.includes("EndFlowActivity") && !visited.has(nestedEndFlow.Id)) {
                                stack.push(...nestedEndFlow.Transitions.map(tr => tr.ActivityId));
                            }
                            
                            continue;
                        }

                        if (node.ThreadId != firstId) {
                            throw { id: curId, message: "Активность выходит за границы параллельного процесса" };
                        }

                        // добавляем все переходы текущей активности для дальнейшего обхода
                        for (let t of node.Transitions) {
                            let next = t.ActivityId ?? t.Activity?.Id;

                            if (next && !visited.has(next))
                                stack.push(next);
                        }
                    }

                    // если ветка не дошла до EndFlowActivity — ошибка
                    if (!reachedEnd) {
                        throw { id: firstId, message: "Параллельный процесс не завершается в EndFlowActivity" };
                    }
                }
            }
        },
        validateSchema(schemeObj, enrichedForParallel = false) {
            let scheme = JSON.parse(JSON.stringify(schemeObj));

            if (!enrichedForParallel) {
                scheme = this.getEnrichedForParallelScheme(JSON.stringify(scheme));
            }

            if (!scheme || !Array.isArray(scheme) || scheme.length <= 0) {
                return { success: false, id: null, message: "Структура схемы повреждена" };
            }
            
            let validationTree = null;
            let map = new Map(scheme.map(a => [a.Id, a]));

            try {
                validationTree = this.buildTree(scheme, map);
                this.validateTree(validationTree);
                this.validateParallels(map);
                return { success: true, id: null, message: "Схема валидна" };
            }
            catch (ex) {
                return { success: false, ...ex };
            }
        },
        getEnrichedForParallelScheme(schemeStr) {
            try {
                let scheme = JSON.parse(schemeStr);

                if (!scheme || !Array.isArray(scheme) || scheme.length <= 0) {
                    return null;
                }

                let map = new Map(scheme.map(a => [a.Id, a]));
                let visited = new Set();
                let stack = [];

                let starts = scheme.filter(a => a.__type.includes('StartActivity'));

                if (starts.length > 1 || starts.length == 0) {
                    return scheme;
                }

                let start = starts[0];
                stack.push(start);

                while (stack.length > 0) {
                    let sourceActivity = stack.pop();

                    if (visited.has(sourceActivity.Id) && !sourceActivity.__type.includes("EndFlowActivity"))
                        continue;
                    
                    visited.add(sourceActivity.Id);

                    for (let transition of sourceActivity.Transitions ?? []) {
                        let targetActivity = map.get(transition.ActivityId);

                        if (targetActivity && (!visited.has(targetActivity.Id) || targetActivity.__type.includes("EndFlowActivity"))) {
                            if (targetActivity.__type.includes("ParallelActivity")) {
                                stack.unshift(targetActivity);
                            }
                            else {
                                stack.push(targetActivity);
                            }
                        }

                        if (targetActivity.__type.includes("EndFlowActivity")) {
                            if (targetActivity.ThreadId == -1 || targetActivity.ThreadId == sourceActivity.ParentId) {
                                targetActivity.ThreadId = sourceActivity.ParentId; // ThreadId = Id ParallelActivity
                                let startingParallel = map.get(sourceActivity.ParentId); // ищем саму ParallelActivity

                                if (startingParallel != undefined && startingParallel.__type.includes("ParallelActivity")) {
                                    targetActivity.ParentId = startingParallel.ParentId; // ParentId EndFlow = ParentId ParallelActivity (возврат в общий поток)
                                    startingParallel.ThreadId = targetActivity.Id; // помечаем чем закрывается ParallelActivity
                                }
                            }
                        }
                        else {
                            // пробрасываем
                            targetActivity.ParentId = sourceActivity.ParentId;
                            targetActivity.ThreadId = sourceActivity.ThreadId;
                        }

                        // Вход из ParallelActivity — старт параллели
                        if (sourceActivity.__type.includes("ParallelActivity")) {
                            targetActivity.ParentId = sourceActivity.Id; // ParentId = Id параллели
                            targetActivity.ThreadId = targetActivity.Id; // ThreadId = Id первой активности потока
                        }
                    }
                }

                return scheme;
            }
            catch {
                return null;
            }
        },
        async privateSave() {
            let validate_result = this.$refs.form.validate();

            if (!validate_result) {
                this.$notify.alert(this.$t("Не_заполнены_обязательные_поля"));
                return;
            }

            if (typeof this.$refs.FlowEditor != 'undefined') {
                let { Diagramm, Scheme } = this.$refs.FlowEditor.save();
                this.dataSource.Data.Object.Diagramm = Diagramm;

                let enrichedSchemeObj = this.getEnrichedForParallelScheme(Scheme);
                let validationError = this.validateSchema(enrichedSchemeObj, true);

                if (!validationError.success) {
                    this.$notify.alert(`Активность(${validationError.id}): ${validationError.message}`);
                    return;
                }

                this.dataSource.Data.Object.Scheme = JSON.stringify(enrichedSchemeObj);
            }
            else if (this.dataSource.Data.Object.is_new_record) {
                this.$notify.alert(this.$t("Схема_процесса_содержит_ошибки"));
                return;
            }

            return await httpAPI({ url: `api/actions/save?type=${type}`, method: 'POST', data: { Content: JSON.stringify({ parent: this.dataSource.Data.Object, childrens: null }) }, headers: { "isCommon": false } });
        },
        async Save() {
            let response = await this.privateSave();

            if (response)
                this.$notify.success(response.data.Payload.Message);
        },
        async SaveAndClose() {
            let response = await this.privateSave();

            if (response) {
                this.dataSource = response.data.Payload;
                this.$notify.success(response.data.Payload.Message);
            }
        },
        async Edit() {
            let response = await httpAPI({ url: `api/actions/edit?type=${type}&id=${this.dataSource.Data.Object.Id}`, method: 'GET', headers: { "isCommon": false } });

            if (response) {
                this.dataSource = { Data: response.data.Payload };
            }
        },
        async DeleteWorkflowScheme() {
            let response = await httpAPI({ url: `api/actions/delete?type=${type}&id=${this.dataSource.Data.Object.Id}`, method: 'DELETE', headers: { "isCommon": false } });

            if (response) {
                this.$notify.success(response.data.Payload.Message);
                await this.$router.replace({ name: 'Workflows' });
            }
        }
    },
    async beforeRouteEnter(to, from, next) {
        let dataSource = null;

        if (to.query.id === 'new')
            dataSource = (await httpAPI({ url: `api/actions/new?type=${type}`, method: 'GET', headers: { "isCommon": false } }))?.data.Payload ?? null;
        else
            dataSource = (await httpAPI({ url: `api/actions/open?type=${type}&id=${to.query.id}`, method: 'GET', headers: { "isCommon": to.query.common } }))?.data.Payload ?? null;
        
        if (!dataSource) return;

        if (dataSource.Data.Object.ContextTypes == null)
            dataSource.Data.Object.ContextTypes = [];
        
        /* if (dataSource.Data.Object.EnterpriseId == sys.guidEmpty())
            dataSource.Data.Object.EnterpriseId = store.getters['global/auth/getUserInfo'].EnterpriseId; */

        next(vm => { vm.dataSource = dataSource; });
    },
    async beforeRouteUpdate(to, from, next) {
        this.dataSource = null;

        if (to.query.id === 'new')
            this.dataSource = (await httpAPI({ url: `api/actions/new?type=${type}`, method: 'GET', headers: { "isCommon": false } }))?.data.Payload ?? null;
        else
            this.dataSource = (await httpAPI({ url: `api/actions/open?type=${type}&id=${to.query.id}`, method: 'GET', headers: { "isCommon": to.query.common } }))?.data.Payload ?? null;

        if (!this.dataSource) return;

        if (this.dataSource.Data.Object.ContextTypes == null)
            this.dataSource.Data.Object.ContextTypes = [];
        
        /* if (this.dataSource.Data.Object.EnterpriseId == this.guidEmpty)
            this.dataSource.Data.Object.EnterpriseId = this.$store.getters['global/auth/getUserInfo'].EnterpriseId; */

        next();
    },
    watch: {
        menu: {
            handler(v) {
                this.$store.commit('documents/toolbar/SET_MENU', { menu: v });
            }
        }
    },
    created() {
		(async() => {
            while(typeof this.$refs.form === 'undefined')
                await new Promise(resolve => setTimeout(resolve, 100));

            this.$refs.form.validate();
        })();
    },
    updated() {
		if (this.dataSource !== null) {
            this.$refs.form.validate();
        }
    }
}
</script>